import {
  approveRefill,
  denyRefill,
  replaceRefill,
} from '@lotushealth/lotushealth_js_sdk/endpoints';
import { lotusHealthZod } from '@lotushealth/lotushealth_js_sdk';
import type {
  ApproveRefillRequestT,
  DenyRefillRequestT,
  ReplaceRefillRequestT,
  ResponseT,
} from '@lotushealth/lotushealth_js_sdk/schemas';

import { createLotusRequestConfig } from '@/shared/api/lotus';

/**
 * Typed transport for the three refill action endpoints. Each call hits the
 * generated SDK and validates the response against the matching Zod schema
 * before handing it back as a typed ``ResponseT``. Mutation hooks should
 * consume this module rather than wiring axios directly.
 */
export const refillAction = {
  async approve(
    refillId: number,
    data: ApproveRefillRequestT,
    signal?: AbortSignal
  ): Promise<ResponseT> {
    const config = await createLotusRequestConfig({ signal });
    const response = await approveRefill(refillId, data, config);
    return lotusHealthZod.approveRefillResponse.parse(response.data) as ResponseT;
  },

  async deny(refillId: number, data: DenyRefillRequestT, signal?: AbortSignal): Promise<ResponseT> {
    const config = await createLotusRequestConfig({ signal });
    const response = await denyRefill(refillId, data, config);
    return lotusHealthZod.denyRefillResponse.parse(response.data) as ResponseT;
  },

  async replace(
    refillId: number,
    data: ReplaceRefillRequestT,
    signal?: AbortSignal
  ): Promise<ResponseT> {
    const config = await createLotusRequestConfig({ signal });
    const response = await replaceRefill(refillId, data, config);
    return lotusHealthZod.replaceRefillResponse.parse(response.data) as ResponseT;
  },
} as const;
